import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import '../../assets/css/styles.css';
const axios = require('axios').default;
var config = require('../../config/config.json');


export default function StudentDashboard(props) {
    document.title = props.title;
    var retrievedUserDetailsObject = JSON.parse(localStorage.getItem('userDetailsLog'));
    let studentTempObj = '';
    const [userLoginDetails, setLoginDetailsValue] = useState(retrievedUserDetailsObject);
    const [courseDetails, setcourseDetails] = useState([]);
    const [degreeDetails, setdegreeDetails] = useState([]);
    // const [allSection, setAllSection] = useState([]);
    // const [yearSemSectionList, setYearSemSectionDetails] = useState([]);
    const [yearList, setYearListDetails] = useState([]);
    const [semesterList, setSemListDetails] = useState([]);
    const [sectionList, setSectionListDetails] = useState([]);

    const [studentClassSemester, setStudentClassSemester] = useState(userLoginDetails.mstr_student_class_semester);
    const [studentClassSection, setStudentClassSection] = useState(userLoginDetails.mstr_section_name);
    const [selectedCourseYear, setSelectedCourseYear] = useState(userLoginDetails.mstr_student_class);
    const [submittedFeedbackDetails, setSubmittedFeedbackDetails] = useState("");
    const [studentFirstName, setStudentFirstName] = useState('');
    const [studentMiddleName, setStudentMiddleName] = useState('');
    const [studentLastName, setStudentLastName] = useState('');
    const [studentCourse, setStudentCourse] = useState('');
    const [studentDegree, setStudentDegree] = useState('');
    const [studentEmail, setStudentEmail] = useState('');

    const [studentProfileObject, setStudentProfileObject] = useState('');

    const navigate = useNavigate();



    useEffect(() => {

        getStudentPersonalDetails();
        getAllDegreeData();
    }, []);

    // useEffect(() => {
    //     getFeedbackSubmittedStatus(studentClassSemester);
    // }, [studentClassSemester]);


    function getFeedbackSubmittedStatus(value) {
        setStudentClassSemester(value);
        axios.post(config.API_URL + 'getSubmittedFeedbackDetails', {
            userId: userLoginDetails.mstr_auto_id,
            userRole: userLoginDetails.role_master_auto_id,
            currentAcademicYear: userLoginDetails.mstr_student_teacher_academic_year,
            classSemester: studentClassSemester ? studentClassSemester : studentTempObj.courseSemester
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            if (response.data.status.status == 1) {
                if (response.data.data != null && response.data.data != "") {
                    setSubmittedFeedbackDetails(response.data.data);
                } else {
                    setSubmittedFeedbackDetails("");
                }
            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function getYear(value) {
        setStudentCourse(value);
        setSelectedCourseYear('');
        setStudentClassSemester('');
        setStudentClassSection('');
        axios.post(config.API_URL + 'getYearList', {
            degreeId: studentDegree ? studentDegree : studentTempObj.degreeId,
            courseId: value
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            if (response.data.status.status == 1) {
                if (response.data.data != null && response.data.data != "") {
                    setYearListDetails(response.data.data);
                    if (studentTempObj) {
                        if (studentTempObj.courseYear) {
                            setSelectedCourseYear(studentTempObj.courseYear);
                            getSemester(studentTempObj.courseYear);
                        }
                    }
                } else {
                    setYearListDetails([]);
                }
            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function getSemester(value) {
        setSelectedCourseYear(value);
        setStudentClassSemester('');
        setStudentClassSection('');
        axios.post(config.API_URL + 'getSemesterList', {
            degreeId: studentDegree ? studentDegree : studentTempObj.degreeId,
            courseId: studentCourse ? studentCourse : studentTempObj.courseId,
            courseYear: value
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            // console.log("Response data", response.data.status.status);
            if (response.data.status.status == 1) {
                if (response.data.data != null && response.data.data != "") {
                    setSemListDetails(response.data.data);
                    if (studentTempObj) {
                        if (studentTempObj.courseSemester) {
                            setStudentClassSemester(studentTempObj.courseSemester);
                            getSection(studentTempObj.courseSemester);
                        }
                    }
                } else {
                    setSemListDetails([]);
                }
            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function getSection(value) {
        setStudentClassSemester(value);
        setStudentClassSection('');
        axios.post(config.API_URL + 'getSectionList', {
            degreeId: studentDegree ? studentDegree : studentTempObj.degreeId,
            courseId: studentCourse ? studentCourse : studentTempObj.courseId,
            courseYear: selectedCourseYear ? selectedCourseYear : studentTempObj.courseYear,
            courseSemester: value
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            // console.log("Response data", response.data.status.status);
            if (response.data.status.status == 1) {
                if (response.data.data != null && response.data.data != "") {
                    setSectionListDetails(response.data.data);
                    if (studentTempObj) {
                        if (studentTempObj.courseSection) {
                            setStudentClassSection(studentTempObj.courseSection);
                            getFeedbackSubmittedStatus(studentTempObj.courseSemester);
                        }
                    }
                } else {
                    setSectionListDetails([]);
                }
            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function getDegreeId(value) {
        setStudentDegree(value)
        axios.post(config.API_URL + 'getDegreeWiseCourseList', {
            degreeId: value
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            // console.log("Response data", response.data.status.status);
            if (response.data.status.status == 1) {
                if (response.data.data != null && response.data.data != "") {
                    setcourseDetails(response.data.data);
                    if (studentTempObj) {
                        setStudentCourse(studentTempObj.courseId);
                        getYear(studentTempObj.courseId);
                    }
                    setSelectedCourseYear('');
                    setStudentClassSemester('');
                    setStudentClassSection('');
                } else {
                    setcourseDetails([]);
                }
            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function getAllDegreeData() {
        axios.post(config.API_URL + 'getAllDegreeData', {
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            if (response.data.status.status == 1) {
                if (response.data.data != null && response.data.data != "") {
                    setdegreeDetails(response.data.data);
                } else {
                    setdegreeDetails([]);
                }
            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function onStudentPersonalInformationSubmitClick(feedbackLink) {

        if (studentFirstName) {
            if (studentLastName) {
                if (studentEmail) {
                    if (studentDegree) {
                        if (studentCourse) {
                            if (selectedCourseYear) {
                                if (studentClassSemester) {
                                    if (studentClassSection) {
                                        axios.post(config.API_URL + 'updateStudentPersonalInfromation', {
                                            userId: userLoginDetails.mstr_auto_id,
                                            studentFirstName: studentFirstName,
                                            studentMiddleName: studentMiddleName,
                                            studentLastName: studentLastName,
                                            studentEmail: studentEmail,
                                            studentDegree: studentDegree,
                                            studentCourse: studentCourse,
                                            studentClassSemester: studentClassSemester,
                                            studentClassSection: studentClassSection,
                                            selectedCourseYear: selectedCourseYear,
                                        }, {
                                            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
                                        }).then(function (response) {
                                            if (response.data.status.status == 1) {
                                                // console.log("response.data.data", userLoginDetails.mstr_student_teacher_first_name);
                                                toast.success(response.data.status.message);
                                                userLoginDetails.mstr_student_teacher_first_name = studentFirstName;
                                                userLoginDetails.mstr_student__teacher_middle_name = studentMiddleName;
                                                userLoginDetails.mstr_student_teacher_last_name = studentLastName;
                                                userLoginDetails.mstr_student_teacher_email = studentEmail;
                                                userLoginDetails.mstr_student_degree = studentDegree;
                                                userLoginDetails.mstr_student_course = studentCourse;
                                                userLoginDetails.mstr_student_class_semester = studentClassSemester;
                                                userLoginDetails.mstr_section_name = studentClassSection;
                                                userLoginDetails.mstr_student_class = selectedCourseYear;
                                                localStorage.setItem('userDetailsLog', JSON.stringify(userLoginDetails));
                                                navigate(feedbackLink);
                                            }
                                        }).catch(function (error) {
                                            toast.error(error);
                                        });
                                    } else {
                                        toast.warning("Please select section");
                                    }
                                } else {
                                    toast.warning("Please select semester");
                                }
                            } else {
                                toast.warning("Please select year");
                            }
                        } else {
                            toast.warning("Please select course");
                        }
                    } else {
                        toast.warning("Please select degree");
                    }
                } else {
                    toast.warning("Please enter email");
                }
            } else {
                toast.warning("Please enter last name");
            }
        } else {
            toast.warning("Please enter first name");
        }
    }

    function getStudentPersonalDetails() {
        setStudentProfileObject('');
        axios.post(config.API_URL + 'getStudentPersonalDetails', {
            inputUserId: userLoginDetails.mstr_auto_id
        }, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' }
        }).then(function (response) {
            if (response.data.status.status == 1) {
                setStudentFirstName(response.data.data[0].mstr_student_teacher_first_name);
                setStudentMiddleName(response.data.data[0].mstr_student__teacher_middle_name);
                setStudentLastName(response.data.data[0].mstr_student_teacher_last_name);
                setStudentEmail(response.data.data[0].mstr_student_teacher_email);
                setStudentDegree(response.data.data[0].mstr_student_degree);

                setStudentCourse(response.data.data[0].mstr_student_course);
                setSelectedCourseYear(response.data.data[0].mstr_student_class);
                setStudentClassSemester(response.data.data[0].mstr_student_class_semester);
                setStudentClassSection(response.data.data[0].mstr_section_name);

                studentTempObj = {
                    'degreeId': response.data.data[0].mstr_student_degree,
                    'courseId': response.data.data[0].mstr_student_course,
                    'courseYear': response.data.data[0].mstr_student_class,
                    'courseSemester': response.data.data[0].mstr_student_class_semester,
                    'courseSection': response.data.data[0].mstr_section_name,
                }
                getDegreeId(response.data.data[0].mstr_student_degree);

            }
        }).catch(function (error) {
            toast.error(error);
        });
    }

    function clickOnLogOut() {
        localStorage.removeItem("userDetailsLog");
        localStorage.removeItem("isAuthenticated");
        localStorage.clear();
        navigate('/Student');
    }

    const LogoURL = require(`../../assets/images/${config.logoUrl}`).default;
    return (
        <div className="index-cover">
            <div className="container main-container">
                <section className='section-header' >
                    <div className='row'>
                        <div className="col-md-12" >
                            <div className='logout-strip'>
                                <div className='link-holder'>
                                    <a className="btn-link" type="button">Welcome {studentFirstName}&nbsp;{studentLastName}&nbsp;</a>
                                    <span className='line-divider'></span>
                                    <a className="btn-link" type="button" onClick={clickOnLogOut}>Logout</a>
                                </div>
                            </div>
                            <div className="college-name" ><img src={LogoURL} className='logo-college' alt='' />{config.collegeName} </div>
                            <div className='feedback-title' >Student Registration Form</div>
                        </div>
                    </div>
                </section>

                <section className='section-userInformation'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='note note-thankyou'>
                                <span style={{ display: 'block', marginBottom: '10px' }}>Dear Students,  </span>We would greatly appreciate your feedback about the college. This will help us to strengthen the college programmes and infrastructure. We request to read the questions carefully answer Your identity and responses will be kept confidential. </div>
                        </div>
                    </div>

                    <div className='row'>
                        <div className="form-group col-md-6">
                            <label htmlFor="name">First Name<em>*</em></label>
                            <input type="text" className="form-control" id="exampleInputFirst" onChange={(e) => setStudentFirstName(e.target.value)} defaultValue={studentFirstName} placeholder="Enter first name" />
                        </div>
                        {/* <div className="form-group col-md-4">
                            <label htmlFor="name">Middle Name<em></em></label>
                            <input type="text" className="form-control" id="exampleInputMiddle" onChange={(e) => setStudentMiddleName(e.target.value)} defaultValue={studentMiddleName} placeholder="Enter middle name" />
                        </div> */}
                        <div className="form-group col-md-6">
                            <label htmlFor="name">Last Name<em>*</em></label>
                            <input type="text" className="form-control" id="exampleInputLast" onChange={(e) => setStudentLastName(e.target.value)} defaultValue={studentLastName} placeholder="Enter last name" />
                        </div>

                    </div>

                    <div className="row">
                        <div className="form-group col-md-4">
                            <label htmlFor="name">Email Address<em>*</em></label>
                            <input type="text" className="form-control" id="exampleInputEmail1" placeholder="Enter email address" onChange={(e) => setStudentEmail(e.target.value)} defaultValue={studentEmail} disabled />
                        </div>
                        {
                            (submittedFeedbackDetails == null || submittedFeedbackDetails == '' ?
                                <div className="form-group col-md-4">
                                    <label htmlFor="name">Select Degree  <em>*</em></label>
                                    <select className="form-control" value={studentDegree} onChange={(e) => getDegreeId(e.target.value)}>
                                        <option value=''>---select degree---</option>
                                        {
                                            degreeDetails.map((e) => (
                                                <option value={e.degreeId}>{e.degreeName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                :
                                <div className="form-group col-md-4">
                                    <label htmlFor="name">Select Degree  <em>*</em></label>
                                    <select className="form-control" value={studentDegree} onChange={(e) => getDegreeId(e.target.value)} disabled>
                                        <option value=''>---select degree---</option>
                                        {
                                            degreeDetails.map((e) => (
                                                <option value={e.degreeId}>{e.degreeName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            )
                        }

                        {
                            (submittedFeedbackDetails == null || submittedFeedbackDetails == '' ?
                                <div className="form-group col-md-4">
                                    <label htmlFor="name">Select Course  <em>*</em></label>
                                    <select className="form-control" value={studentCourse} onChange={(e) => getYear(e.target.value)}>
                                        <option value=''>---select course---</option>
                                        {
                                            courseDetails.map((e) => (
                                                <option value={e.courseId}>{e.courseName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                :
                                <div className="form-group col-md-4">
                                    <label htmlFor="name">Select Course  <em>*</em></label>
                                    <select className="form-control" value={studentCourse} onChange={(e) => getYear(e.target.value)} disabled>
                                        <option value=''>---select course---</option>
                                        {
                                            courseDetails.map((e) => (
                                                <option value={e.courseId}>{e.courseName}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            )
                        }

                    </div>

                    <div className="row">
                        {
                            (submittedFeedbackDetails == null || submittedFeedbackDetails == '' ?
                                <div className="form-group col-md-4">
                                    <label>Select Year  <em>*</em></label>
                                    <select className="form-control" value={selectedCourseYear} onChange={(e) => getSemester(e.target.value)}>
                                        <option value=''>---select year---</option>
                                        {
                                            yearList.map((item) => (
                                                <option value={item.course_year}>{item.course_year}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                :
                                <div className="form-group col-md-4">
                                    <label>Select Year  <em>*</em></label>
                                    <select className="form-control" value={selectedCourseYear} onChange={(e) => getSemester(e.target.value)} disabled>
                                        <option value=''>---select year---</option>
                                        {
                                            yearList.map((item) => (
                                                <option value={item.course_year}>{item.course_year}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            )
                        }

                        {
                            (submittedFeedbackDetails == null || submittedFeedbackDetails == '' ?
                                <div className="form-group col-md-4">
                                    <label>Semester currently studying in  <em>*</em></label>
                                    <select className="form-control" value={studentClassSemester} onChange={(e) => getSection(e.target.value)}>
                                        <option value=''>---select semester---</option>
                                        {
                                            semesterList.map((item) => (
                                                <option value={item.course_sem}>{item.course_sem}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                                :
                                <div className="form-group col-md-4">
                                    <label>Semester currently studying in  <em>*</em></label>
                                    <select className="form-control" value={studentClassSemester} onChange={(e) => getSection(e.target.value)} disabled>
                                        <option value=''>---select semester---</option>
                                        {
                                            semesterList.map((item) => (
                                                <option value={item.course_sem}>{item.course_sem}</option>
                                            ))
                                        }
                                    </select>
                                </div>
                            )
                        }

                        {
                            (submittedFeedbackDetails == null || submittedFeedbackDetails == '' ?
                                <div className="form-group col-md-4">
                                    <label htmlFor="name">Select Section  <em>*</em></label>
                                    <select className="form-control" value={studentClassSection} onChange={(e) => setStudentClassSection(e.target.value)}>
                                        <option value=''>---select section---</option>
                                        {
                                            sectionList.map((e) => (
                                                <option value={e.section_id}>{e.section_id}</option>
                                            ))
                                        }
                                    </select>
                                    <span>If no section is allocated, please select Section A</span>
                                </div>
                                :
                                <div className="form-group col-md-4">
                                    <label htmlFor="name">Select Section  <em>*</em></label>
                                    <select className="form-control" value={studentClassSection} onChange={(e) => setStudentClassSection(e.target.value)} disabled>
                                        <option value=''>---select section---</option>
                                        {
                                            sectionList.map((e) => (
                                                <option value={e.section_id}>{e.section_id}</option>
                                            ))
                                        }
                                    </select>
                                    <span>If no section is allocated, please select Section A</span>
                                </div>
                            )
                        }

                    </div>

                    <div className='row'>
                        <div className='row-feedbackbox '>
                            <div className="col-md-12">
                                <button className='btn btn-primary btn-startSurvey btn-block' onClick={() => onStudentPersonalInformationSubmitClick('/StudentDashboard')}>Save & Next</button>
                            </div>
                        </div>
                    </div>

                </section>
                <section className='section-footer'>
                    <div className='row'>
                        <div className='footer'>
                            <div className='col-md-6 col-sm-6' >{config.collegeName}, Feedback System {config.version}</div>
                            <div className='col-md-6 col-sm-6 text-poweredBy'>{config.PoweredBy}</div>
                        </div>
                    </div>
                </section>
            </div>
            <ToastContainer />
        </div>
    )
}